import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'osre-expired-invitation-page',
  templateUrl: './expired-invitation-page.component.html',
  styleUrls: ['./expired-invitation-page.component.scss']
})
export class ExpiredInvitationPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
